import {Circle, DollarSign, Users} from 'react-feather'

export default [
    {
        header: 'Finanzas',
        action: 'level-1',
        resource: 'Common'
    },
    {
        id: 'Wallet',
        title: 'Bancamiga Wallet',
        action: 'level-1',
        resource: 'Common',
        icon: <DollarSign size={20}/>,
        children: [
            {
                id: 'Retiro',
                title: 'Retiro de fondos',
                icon: <Circle size={12}/>,
                action: 'level-1',
                resource: 'Common',
                navLink: '/common/bancamiga-wallet/withdrawal'
            }
        ]
    },
    {
        header: 'Administración',
        action: 'level-1',
        resource: 'Common'
    },
    {
        id: 'workTeam',
        title: 'Operadores',
        action: 'level-1',
        resource: 'Common',
        icon: <Users size={20} />,
        navLink: '/common/work-team/operational-users'
    }


]